import React, { useEffect, useState } from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";


import logo_left from "../../assets/01_Home/Icon_Left.svg";
import logo_right from "../../assets/01_Home/Icon_Right.svg";
import { useLocation } from "react-router-dom";

interface ContenidoComunidadHyundaiComponentProps {
  comunidad: any;
}

const ContenidoComunidadHyundaiComponent: React.FC<
  ContenidoComunidadHyundaiComponentProps
> = ({ comunidad }) => {
  const location = useLocation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const handleLoad = () => {
      setIsVisible(true);
    };

    handleLoad();
  }, [location]);

  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        goToNext();
      }, 7000);
      return () => clearInterval(interval);
    }
  }, [currentIndex, isHovered]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? comunidad.length - 1 : prevIndex - 1));
    setImageIndex(0);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === comunidad.length - 1 ? 0 : prevIndex + 1));
    setImageIndex(0);
  };

  const goToPreviousImage = () => {
    setImageIndex((prevIndex) => (prevIndex - 1 + 3) % 3);
  };

  const goToNextImage = () => {
    setImageIndex((prevIndex) => (prevIndex + 1) % 3);
  };

  return (
    <div
      className="contenido-comunidad-hyundai-component"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={(e) => setTouchStart(e.targetTouches[0].clientX)}
      onTouchMove={(e) => setTouchEnd(e.targetTouches[0].clientX)}
      onTouchEnd={() => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        if (distance > 50) goToNext();
        if (distance < -50) goToPrevious();
        setTouchStart(null);
        setTouchEnd(null);
      }}
    >
      <button className="prev-post" onClick={goToPrevious}>
        <img src={logo_left} alt="Ícono de flecha izquierda" />
      </button>
      <div className="slider-comunidad-hyundai-component" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
        {comunidad?.map((item: any, index: number) => (
          <div
            key={index}
            className={`active-contenido-comunidad-component ${currentIndex === index ? "visible" : ""}`}
          >
            <div className="img-contenido-comunidad-component">
              <button className="btn-prev-image" onClick={goToPreviousImage}>
                <img src={logo_left} alt="Imagen anterior" />
              </button>
              {item?.["image" + (imageIndex + 1)]?.url ? (
                <img
                  className="img-carroucel"
                  src={buildCmsUrl(item["image" + (imageIndex + 1)].url)}

                  srcSet={getSrcSet(item["image" + (imageIndex + 1)].url || '')}
                  sizes={getSizes('600px')}
                  alt={`Imagen ${imageIndex + 1} de ${item?.username || "usuario"}`}
                />

              ) : (
                <div className="img-carroucel" style={{ width: "100%" }}></div>
              )}
              <button className="btn-next-image" onClick={goToNextImage}>
                <img src={logo_right} alt="Imagen siguiente" />
              </button>
            </div>
            <div className="detalle-contenido-comunidad-component">
              <div className="title">{item?.username}</div>
              <div className="date">{item?.published_datetime}</div>
              <div className="description">{item?.description}</div>
            </div>
          </div>
        ))}
      </div>
      <button className="next-post" onClick={goToNext}>
        <img src={logo_right} alt="Ícono de flecha derecha" />
      </button>
    </div>
  );
};

export default ContenidoComunidadHyundaiComponent;
